import React, { useEffect, useState } from 'react';
import { HiUserGroup } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { MdEmail, MdSignalWifiStatusbarConnectedNoInternet4 } from 'react-icons/md';
import { ImConnection } from 'react-icons/im';
import { BsPhoneVibrate } from 'react-icons/bs';
import { FaUserCircle } from 'react-icons/fa';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import LoaderBootStrap from '../../../components/admin/dasboard/LoaderBootStrap';
import { LoadAllMessage } from '../../../actions/Messages/MessageAction';
import moment from 'moment';

const ListMessagePage = () => {
  const navigate = useNavigate();
  const [messagelist, setmessagelist] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredMessages, setFilteredMessages] = useState([]);

  useEffect(() => {
    LoadAllMessage(setmessagelist);
  }, []);

  const handleShowModal = (message) => {
    setSelectedMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedMessage(null);
    setShowModal(false);
  };

  const handleFilter = () => {
    if (startDate && endDate) {
      const start = moment(startDate).startOf('day');
      const end = moment(endDate).endOf('day');
      const filtered = messagelist.filter((message) => {
        const createdAt = moment(message.createdAt);
        return createdAt.isBetween(start, end);
      });
      setFilteredMessages(filtered);
    } else {
      setFilteredMessages(messagelist);
    }
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.setProperties({
      title: 'Message envoyers sur le site web',
      subject: 'Messages de plenitude',
      author: 'Message',
    });

    doc.text('Liste des Messages envoyés sur le site web ', 14, 10);
    doc.autoTable({
      head: [['Nom', 'Email', 'Sujet', 'Téléphone', 'Contenu', 'Date']]
      ,
      body: filteredMessages.map((msg) => [
        msg.name,
        msg.email,
        msg.subject,
        msg.telephone,
        msg.content,
        moment(msg.createdAt).format('DD-MM-YYYY HH:mm')
      ]),
    });
    doc.save('messages.pdf');
  };

  return (
    <div className="translatable container mx-auto mt-1">
      <h1 className="translatable text-center mb-4 py-3 bg-blue-700 text-white rounded-2xl text-2xl">Liste des Messages</h1>

      <div className="translatable mb-4">
        <Form>
          <div className="translatable d-flex justify-content-between align-items-center">
            <Form.Group controlId="startDate" className="translatable me-2">
              <Form.Label>Date de début</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="endDate" className="translatable me-2">
              <Form.Label>Date de fin</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Form.Group>
            <Button variant="success" onClick={handleFilter} className="translatable mt-4 btn btn-outline-dark">
              Filtrer
            </Button>
          </div>
        </Form>
      </div>

      <Button variant="success" onClick={exportPDF} className="translatable mb-3 btn btn-outline-dark">
        Exporter en PDF
      </Button>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nom</th>
            <th>Email</th>
            <th>Sujet</th>
            <th>Téléphone</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {(filteredMessages.length > 0 ? filteredMessages : messagelist).map((message) => (
            <tr key={message._id}>
              <td>{message.name}</td>
              <td>{message.email}</td>
              <td>{message.subject}</td>
              <td>{message.telephone}</td>
              <td>{message.telephone}</td>
              <td>
                <Button variant="info" onClick={() => handleShowModal(message)}>
                  Voir
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Détails du Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMessage && (
            <div>
              <p><strong>Nom:</strong> {selectedMessage.name}</p>
              <p><strong>Email:</strong> {selectedMessage.email}</p>
              <p><strong>Email:</strong> {moment(selectedMessage.createdAt).format("DD-MM-YYYY HH:MM")}</p>
              <p><strong>Sujet:</strong> {selectedMessage.subject}</p>
              <p><strong>Téléphone:</strong> {selectedMessage.telephone}</p>
              <p><strong>Contenu:</strong> {selectedMessage.content}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ListMessagePage;
